import { botstacksExpertPartnership } from './botstacks.js';
import { bubbleExpertPartnership } from './bubble.js';
import { buildshipExpertPartnership } from './buildship.js';
import { contraExpertTestPartnership } from './contra-test.js';
import { descriptExpertPartnership } from './descript.js';
import { flutterflowExpertPartnership } from './flutterflow.js';
import { framerExpertPartnership } from './framer.js';
import { glorifyExpertPartnership } from './glorify.js';
import { heyGenExpertPartnership } from './hey-gen.js';
import { instantExpertPartnership } from './instant.js';
import { jitterExpertPartnership } from './jitter.js';
import { kittlExpertPartnership } from './kittl.js';
import { lottiefilesFigmaExpertPartnership } from './lottiefiles-figma.js';
import { lottiefilesFramerExpertPartnership } from './lottiefiles-framer.js';
import { lottiefilesWebflowExpertPartnership } from './lottiefiles-webflow.js';
import { relumeExpertPartnership } from './relume.js';
import { reploExpertPartnership } from './replo.js';
import { riveExpertPartnership } from './rive.js';
import { splineExpertPartnership } from './spline.js';
import { webflowExpertPartnership } from './webflow.js';
import { webstudioExpertPartnership } from './webstudio.js';
import { wixStudioExpertPartnership } from './wix-studio.js';
export const expertPartnerships = {
    BOTSTACKS_EXPERT: botstacksExpertPartnership,
    BUBBLE_EXPERT: bubbleExpertPartnership,
    BUILDSHIP_EXPERT: buildshipExpertPartnership,
    CONTRA_EXPERT_TEST: contraExpertTestPartnership,
    DESCRIPT_EXPERT: descriptExpertPartnership,
    FLUTTERFLOW_EXPERT: flutterflowExpertPartnership,
    FRAMER_EXPERT: framerExpertPartnership,
    GLORIFY_EXPERT: glorifyExpertPartnership,
    HEY_GEN_EXPERT: heyGenExpertPartnership,
    INSTANT_EXPERT: instantExpertPartnership,
    JITTER_EXPERT: jitterExpertPartnership,
    KITTL_EXPERT: kittlExpertPartnership,
    LOTTIEFILES_X_FIGMA_EXPERT: lottiefilesFigmaExpertPartnership,
    LOTTIEFILES_X_FRAMER_EXPERT: lottiefilesFramerExpertPartnership,
    LOTTIEFILES_X_WEBFLOW_EXPERT: lottiefilesWebflowExpertPartnership,
    RELUME_EXPERT: relumeExpertPartnership,
    REPLO_EXPERT: reploExpertPartnership,
    RIVE_EXPERT: riveExpertPartnership,
    SPLINE_EXPERT: splineExpertPartnership,
    WEBFLOW_EXPERT: webflowExpertPartnership,
    WEBSTUDIO_EXPERT: webstudioExpertPartnership,
    WIX_STUDIO_EXPERT: wixStudioExpertPartnership,
};
//# sourceMappingURL=index.js.map